<template>
  <v-checkbox base-color="primary" color="primary" density="compact" hide-details>
    <template v-if="$slots.label" #label="slotData">
      <slot name="label" v-bind="slotData" />
    </template>
  </v-checkbox>
</template>

<script setup lang="ts">
defineOptions({
  name: 'SfCheckbox'
})
</script>
